import { isUnsupportedCardHolderRegionError } from "./errors"

export type TCardHolderRecovery = "phone" | "kyc" | "error"

const BUYER_FIELDS = new Set(["area_code", "mobile", "address.city_code"])

const normalizeField = (field: unknown) => {
	return String(field || "")
		.toLowerCase()
		.trim()
		.split(".")
		.filter(Boolean)
		.join(".")
}

const detailsText = (details: unknown) => {
	if (Array.isArray(details)) return details.map(String).join(" ").toLowerCase()
	if (details && typeof details === "object") {
		try {
			return JSON.stringify(details).toLowerCase()
		} catch {
			return ""
		}
	}
	return String(details ?? "").toLowerCase()
}

/** Chooses the recovery screen for backend CARD_HOLDER_INCOMPLETE (2201). */
export const getCardHolderRecovery = (error: {
	details?: unknown
	missing_fields?: readonly unknown[]
}): TCardHolderRecovery => {
	if (isUnsupportedCardHolderRegionError({ ...error, code: 2201, message: "" })) return "error"
	const missing = Array.isArray(error.missing_fields)
		? error.missing_fields.map(normalizeField).filter(Boolean)
		: []
	if (missing.length > 0) {
		return missing.every(field => BUYER_FIELDS.has(field)) ? "phone" : "kyc"
	}

	const details = detailsText(error.details)
	if (details.includes("kyc/phone")) return "phone"
	if (details.includes("kyc/start")) return "kyc"
	return "error"
}
